'use client';

import { useStore } from 'zustand';

import { SearchResultsSource } from '@/app/(main)/_components/search-modal/search-modal.types';
import { useFeatureFlag } from '@/feature-flags/hooks/use-feature-flag.hook';
import { useSearchParams } from '@/hooks/use-search-params.hook';
import { userLocationStore } from '@/store/user-location.store';
import { PersistedUserNavigationSearchParams } from '@/types/enums/persisted-user-navigation-search-params.enum';
import { resolveCitySlug } from '@/utils/formatters/city/resolve-city-slug.util';

export interface UseSearchSourceResult {
  source: SearchResultsSource;
  citySlug?: string;
  isLoading: boolean;
}

export function useSearchSource(): UseSearchSourceResult {
  const userLocation = useStore(userLocationStore, (state) => state.userLocation);
  const { getParam } = useSearchParams([PersistedUserNavigationSearchParams.CIDADE]);
  const { value: newSearchModalDesign, loading: designIsLoading } = useFeatureFlag('newSearchModalDesign');
  const { value: newSearchModalSource, loading: sourceIsLoading } = useFeatureFlag('newSearchModalSource');

  return {
    source: newSearchModalSource && newSearchModalDesign ? 'search-api' : 'legacy',
    citySlug: resolveCitySlug(getParam(PersistedUserNavigationSearchParams.CIDADE), userLocation),
    isLoading: designIsLoading || sourceIsLoading,
  };
}
